export default function IconContainer(props) {
  const width = props.width || 24
  const height = props.height || 24
  const viewBox = props.viewBox || `0 0 ${width} ${height}`
  const role = props.role || 'presentation'
  const fill = props.fill || 'black'
  const fillRule = props.fillRule || 'nonzero'
  const stroke = props.stroke || 'none'
  const strokeWidth = props.strokeWidth || '1px'
  const strokeLinecap = props.strokeLinecap || 'butt'
  const strokeLinejoin = props.strokeLinejoin || 'miter'
  const clipRule = props.clipRule || 'nonzero'
  const ariaLabel = props.ariaLabel || 'icon'

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      style={props.style}
      width={width}
      height={height}
      viewBox={viewBox}
      role={role}
      fill={fill}
      fillRule={fillRule}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap={strokeLinecap}
      strokeLinejoin={strokeLinejoin}
      clipRule={clipRule}
      aria-label={ariaLabel}
      onClick={props.onClick}
    >
      {props.children}
    </svg>
  )
}
